import MobileWebUserBlocker from './MobileWebUserBlocker'

export default MobileWebUserBlocker
